module.exports = __webpack_public_path__ + "media/img/cart-cancelled-33fb1597ef8f742199865cf2e829ecd5.png";